export const STATE = 'STATE';
export const COUNTY = 'COUNTY';
export const MPO = 'MPO';
export const UA = 'UA';
export const DEFAULT_GEOLEVEL = COUNTY;
export const DEFAULT_MEASURE = 'phed';
